import { SourceIcon } from 'component-library-and-tools';
import React from 'react';
import styled, { css } from 'styled-components';

import { getDestinationLabelAndIcon } from '../../utils/destination';

import { DestinationProps } from './types';

const StyledContainer = styled.div`
  display: inline-flex;
  align-items: center;
`;

const StyledIcon = styled(SourceIcon)<{ hasLabel: boolean }>`
  && {
    font-size: 1.75rem;

    ${({ hasLabel }) => hasLabel && css`
      margin-right: 0.416666667rem;
    `}
  }
`;

const StyledLabel = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const Destination = ({
  destination,
  withLabel = true,
  className,
  iconClassName,
  labelClassName,
}: DestinationProps) => {
  const {label, icon} = getDestinationLabelAndIcon(destination.type);
    
  return (
    <StyledContainer className={className}>
      <StyledIcon name={label} icon={icon} hasLabel={withLabel}/>
      {withLabel && (
        <StyledLabel className={labelClassName} title={label}>
          {label}
        </StyledLabel>
      )}
    </StyledContainer>
  );
};

export default Destination;
